<script setup lang="ts">
import { computed } from "vue";

import type { StickyChange } from "@/model/change";
import { relativeDate } from "@/utils/dateFormat";

import { useStickyChangeEnlarge } from "../internal/useStickyChangeEnlarge";
import ListItemStickyActivity from "./ListItemStickyActivity.vue";
import { groupByDay } from "./groupChanges";

const props = defineProps<{
  changes: StickyChange[];
  showCards?: boolean;
  disableEnlarge?: boolean;
}>();

const changesByDay = computed(() => groupByDay(props.changes));

const { expandedItemId, handleExpanded } = useStickyChangeEnlarge(props.disableEnlarge);
</script>

<template>
  <template v-for="(dayChange, dayIndex) in changesByDay" :key="dayIndex">
    <li class="day-header">
      <span>
        {{ relativeDate(dayChange.date) }}
      </span>
    </li>
    <ListItemStickyActivity
      v-for="change in dayChange.changes"
      :key="change.id"
      :change
      :show-card="showCards"
      :expanded="expandedItemId === change.id"
      @expanded="(opened) => handleExpanded(opened, change.stickyId, change.id)"
    />
  </template>
</template>

<style lang="scss" scoped>
@use "@/styles/mixins/typography";
@use "@/styles/mixins/shadow";
@use "@/styles/variables/colors";
@use "@/styles/z-index";

.day-header {
  @include typography.small("bold");
  @include shadow.date-header;

  position: sticky;
  top: 0;

  // Render above positioned change content (.field-wrapper is position: relative),
  z-index: z-index.$low;
  padding: 8px 16px;
  color: colors.$text;
  background-color: colors.$background-ui;
}
</style>
